<template>
  <div>
    <div v-if="starter">
      <h4>Details for {{starter.title}}</h4>
      <b-form>
        <b-form-group v-for="(field, i) in fields" :key="'field-'+i">
          <label class="field-label" for="field">{{field[1]}}</label>
          <div class="field-value">{{starter[field[0]] || '---'}}</div>
          <hr />
        </b-form-group>
        <BFR :node="starter.node" />
      </b-form>
    </div>
  </div>
</template>

<script>
import BFR from "./BFR.vue";

export default {
  name: "starter",
  components: {
    BFR
  },
  props: {
    starter: {}
  },
  data: () => ({
    loading: false,
    errors: [],
    filter: "",
    fields: [
      ["title", "Title"],
      ["manufacturer", "Manufacturer"],
      ["modelNo", "Model Number"],
      ["size", "Size"],
      ["maxHpRating", "HP Rating"],
      ["fuseClipAmperes", "Fuse Clip Amperes"],
      ["enclosureType", "Enclosure Type"],
      ["controlVoltage", "Control Voltage"],
    ]
  }),
  methods: {}
};
</script>

<style lang="scss" scoped>
</style>
